module.exports = __webpack_public_path__ + "img/no-drive.2ea2af47.svg";